const cssValidator = require('w3c-css-validator');

class CssBuilderCtrl {
  colorNames = {'aliceblue':'#f0f8ff','antiquewhite':'#faebd7','aqua':'#00ffff','aquamarine':'#7fffd4','azure':'#f0ffff','beige':'#f5f5dc','bisque':'#ffe4c4',
    'black':'#000000','blanchedalmond':'#ffebcd','blue':'#0000ff','blueviolet':'#8a2be2','brown':'#a52a2a','burlywood':'#deb887','cadetblue':'#5f9ea0',
    'chartreuse':'#7fff00','chocolate':'#d2691e','coral':'#ff7f50','cornflowerblue':'#6495ed','cornsilk':'#fff8dc','crimson':'#dc143c','cyan':'#00ffff',
    'darkblue':'#00008b','darkcyan':'#008b8b','darkgoldenrod':'#b8860b','darkgray':'#a9a9a9','darkgreen':'#006400','darkkhaki':'#bdb76b','darkmagenta':'#8b008b',
    'darkolivegreen':'#556b2f','darkorange':'#ff8c00','darkorchid':'#9932cc','darkred':'#8b0000','darksalmon':'#e9967a','darkseagreen':'#8fbc8f',
    'darkslateblue':'#483d8b','darkslategray':'#2f4f4f','darkturquoise':'#00ced1','darkviolet':'#9400d3','deeppink':'#ff1493','deepskyblue':'#00bfff',
    'dimgray':'#696969','dodgerblue':'#1e90ff','firebrick':'#b22222','floralwhite':'#fffaf0','forestgreen':'#228b22','fuchsia':'#ff00ff','gainsboro':'#dcdcdc',
    'ghostwhite':'#f8f8ff','gold':'#ffd700','goldenrod':'#daa520','gray':'#808080','green':'#008000','greenyellow':'#adff2f','honeydew':'#f0fff0',
    'hotpink':'#ff69b4','grey':'#808080','indianred ':'#cd5c5c','indigo':'#4b0082','ivory':'#fffff0','khaki':'#f0e68c','lavender':'#e6e6fa',
    'lavenderblush':'#fff0f5','lawngreen':'#7cfc00','lemonchiffon':'#fffacd','lightblue':'#add8e6','lightcoral':'#f08080','lightcyan':'#e0ffff',
    'lightgoldenrodyellow':'#fafad2','lightgrey':'#d3d3d3','lightgreen':'#90ee90','lightpink':'#ffb6c1','lightsalmon':'#ffa07a','lightseagreen':'#20b2aa',
    'lightskyblue':'#87cefa','lightslategray':'#778899','lightsteelblue':'#b0c4de','lightyellow':'#ffffe0','lime':'#00ff00','limegreen':'#32cd32',
    'linen':'#faf0e6','magenta':'#ff00ff','maroon':'#800000','mediumaquamarine':'#66cdaa','mediumblue':'#0000cd','mediumorchid':'#ba55d3',
    'mediumpurple':'#9370d8','mediumseagreen':'#3cb371','mediumslateblue':'#7b68ee','mediumspringgreen':'#00fa9a','mediumturquoise':'#48d1cc',
    'mediumvioletred':'#c71585','midnightblue':'#191970','mintcream':'#f5fffa','mistyrose':'#ffe4e1','moccasin':'#ffe4b5','navajowhite':'#ffdead',
    'navy':'#000080','oldlace':'#fdf5e6','olive':'#808000','olivedrab':'#6b8e23','orange':'#ffa500','orangered':'#ff4500','orchid':'#da70d6', 
    'palegoldenrod':'#eee8aa','palegreen':'#98fb98','paleturquoise':'#afeeee','palevioletred':'#d87093','papayawhip':'#ffefd5','peachpuff':'#ffdab9',
    'peru':'#cd853f','pink':'#ffc0cb','plum':'#dda0dd','powderblue':'#b0e0e6','purple':'#800080','rebeccapurple':'#663399','red':'#ff0000','rosybrown':'#bc8f8f',
    'royalblue':'#4169e1','saddlebrown':'#8b4513','salmon':'#fa8072','sandybrown':'#f4a460','seagreen':'#2e8b57','seashell':'#fff5ee','sienna':'#a0522d',
    'silver':'#c0c0c0','skyblue':'#87ceeb','slateblue':'#6a5acd','slategray':'#708090','snow':'#fffafa','springgreen':'#00ff7f','steelblue':'#4682b4',
    'tan':'#d2b48c','teal':'#008080','thistle':'#d8bfd8','tomato':'#ff6347','turquoise':'#40e0d0','violet':'#ee82ee','wheat':'#f5deb3','white':'#ffffff',
    'whitesmoke':'#f5f5f5','yellow':'#ffff00','yellowgreen':'#9acd32'};

  defaultPropNames = ['background-color','border','color','font-family','font-size','font-style','font-weight','height','left','line-height','outline','text-align','top','width','z-index'];
  pagePropNames = [
    'width', 'height',
    'margin', 'margin-left', 'margin-right', 'margin-top', 'margin-bottom', 
    'padding', 'padding-left', 'padding-right', 'padding-top',
    'background-color', 'background-image', 'background-repeat', 'background-position', 'background-size',
    'border', 'border-left', 'border-right', 'border-top', 'border-bottom', 'border-color', 'border-style', 'border-width',
    'color'];
  fixedProp = null;
  fixedProps = {
    'font-family': ['arial', 'cursive', 'fantasy', 'monospace', 'sans-serif', 'serif', 'system-ui'], 
    'font-style': ['normal', 'italic', 'oblique'],
    'font-weight': ['normal', 'bold', 'bolder', 'lighter', '100', '200', '300', '400', '500', '600', '700', '800', '900'],
    'font-size': {
      'static': ['0.5vw', '0.8vw', '1vw', '1.5vw', '2vw', '2.5vw', '3vw', '3.5vw', '4vw', '4.5vw', '5vw', '5.5vw', '6vw', '6.5vw', '7vw', '7.5vw', '8vw', '8.5vw', '9vw', '9.5vw', '10vw'],
      'dynamic': ['8px', '9px', '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '36px', '48px', '72px']
    },
    'text-align': ['center', 'left', 'right', 'justify']
  };
  pagePresets = [
    { name: 'Letter (8.5 x 11)', styles: { height: '11in', width: '8.5in', margin: '0.75in' } },
    { name: 'Legal (8.5 x 14)', styles: { height: '14in', width: '8.5in', margin: '0.75in' } },
    { name: 'Half Letter (5.5 x 8.5)', styles: { height: '5.5in', width: '8.5in', margin: '0.75in' } },
    { name: 'Government Letter (8 x 10)', styles: { height: '10in', width: '8in', margin: '0.75in' } },
    { name: 'Junior Legal (8 x 5)', styles: { height: '5in', width: '8in', margin: '0.75in' } },
    { name: 'Government Legal (13 x 8.5)', styles: { height: '8.5in', width: '13in', margin: '0.75in' } },
    { name: 'Ledger / Tabloid (11 x 17)', styles: { height: '17in', width: '11in', margin: '0.75in' } },
    { name: 'Widescreen (13.333 x 7.5)', styles: { height: '7.5in', width: '13.333in', margin: '0in' } },
    { name: 'Mobile (5 x 3.8)', styles: { height: '5in', width: '3.8in', margin: '0in' } }
  ];
  skipCopyStyles = ['top', 'left'];

  constructor(TBService, EventService, FlashService, UrlClipCopy, TemplateService, $window) {
    'ngInject';
    Object.assign(this, { $window });
    this.tb = TBService;
    this.ts = TemplateService;
    this.es = EventService;
    this.fs = FlashService;
    this.uc = UrlClipCopy;
    this.pickerColor = '#000000';
    this.validNewProperty = false;
  }

  async $onInit() {

    const td = await this.ts.getTemplateData();
    this.templateType = td.template.type || 'static';
    this.validate = this.validate ?? false;
    this.styleRegex = this.styleRegex || [];
    this.invalidProps = this.invalidProps || [];
    this.allowCustomProps = this.allowCustomProps ?? true;

    this.availableProps = 
      (this.validProps || (this.pageStyles ? this.pagePropNames : this.defaultPropNames))
        .filter(p => !this.invalidProps.includes(p)).sort();
    this.parsedCss = this.tb.getCssObj(this.css);
    this.origParsedCss = {...this.parsedCss};
    this.invalidProps.forEach(p => delete this.parsedCss[p]);

    this.updateCssElements();
    this.pageStyles && this.selectPageSettingMatch();

    this.es.subscribeEvent(
      this.es.actions.ELEMENT_STYLE_UPDATED, 
      (styles) => { this.updateStyles(styles) },
      'ELEMENT_STYLE_UPDATED');
  }

  selectPageSettingMatch() {
    this.pagePreset = this.pagePresets.find(p => {
      const sizeMatch = (this.parsedCss["width"] == p.styles["width"]) && (this.parsedCss["height"] == p.styles["height"]);
      const marginStyles = Object.keys(this.parsedCss).filter(k => k.startsWith("margin"));
      const allMarginsMatch = marginStyles.every(k => 
        (this.parsedCss[k] == p.styles[k] || (!p.styles[k] && this.parsedCss[k] == p.styles["margin"])));
      const hasAllMarginStyles = this.parsedCss["margin"] || (!this.parsedCss["margin"] && marginStyles.length > 3);
      return sizeMatch && allMarginsMatch && hasAllMarginStyles;
    });
  }

  updateStyles(styles) {
    this.parsedCss = { ...this.parsedCss, ...styles };
    this.updateCssElements();
    this.clearOptions();
    this.invalidCss = false;
  }

  clearOptions() {
    this.newProp = undefined;
    this.newVal = undefined;
    this.pickerColor = undefined;
  }

  changePropName() {
    this.pickerColor = undefined;
    this.newVal = this.parsedCss[this.newProp] || undefined;
    this.updatePickerColor(true);
    this.updatePropValues(this.newProp);
  }
  
  updateCssElements() {
    this.cssElements = 
      Object.keys(this.parsedCss).map(k => { return { prop: k, value: this.parsedCss[k] } })
        .sort((a, b) => { return a.prop.localeCompare(b.prop) });
    this.css = this.tb.getLayoutFromCssObj(this.parsedCss);
    if (this.removedProps) this.removedProps = Object.keys(this.origParsedCss).filter(key => this.parsedCss[key] === undefined);
  }
 
  updateProp(propName) {
    this.newProp = propName;
    this.newVal = this.parsedCss[propName];
    this.updatePickerColor(true);
    if (this.customProp && this.availableProps.includes(propName)) this.customProp = false;
    if (!this.customProp && !this.availableProps.includes(propName)) this.customProp = true;
    this.updatePropValues(propName);
  }

  updatePropValues(propName) {
    this.fixedProp = (this.fixedProps[propName] || {})[this.templateType] || this.fixedProps[propName];
    this.customVal = !this.fixedProp || (this.newVal && !this.fixedProp.includes(this.newVal));
  }

  removeProp(prop) {
    //if(!confirm(`Remove current '${prop}' setting?`)) return;
    delete this.parsedCss[prop];
    this.clearOptions();
    this.updateCssElements();
  }

  updatePickerColor(force) {
    if (this.newVal) {
      if (this.newVal.startsWith('rgb(')) {
        this.newVal = "#" + this.newVal.replace(/[^0-9,]/g, "").split(',').map(num => parseInt(num).toString(16).padStart(2, '0')).join('');
      }
      const hex = this.colorNames[this.newVal];
      if (hex) this.pickerColor = hex;
      else if (force) this.pickerColor = this.newVal;
    }
  }

  updateValColor() {
    this.newVal = this.pickerColor;
    this.invalidCss = true;
  }

  async addProp($event) {

    $event.preventDefault();

    this.invalidValue = '';
    this.invalidProperty = false;
    this.invalidCss = true;
    
    this.newProp = this.newProp.toLowerCase().trim();
    this.newVal = this.newVal.replace(/"/g, "'");

    if (this.invalidProps.includes(this.newProp)) {
      this.fs.error(`Invalid property: "${this.newProp}"`);
      this.invalidCss = false;
      return;
    }
    if (this.parsedCss[this.newProp] === this.newVal) {
      this.fs.warning(`No change detected!`);
      this.invalidCss = false;
      return;
    }

    const regexError = this.styleRegex.find(s => {
      return s.styles.includes(this.newProp) && !this.newVal.match(s.regex);
    });
    if (regexError) {
      this.invalidValue = `Invalid value for ${this.newProp}: ${regexError.message}`;
      this.invalidCss = false;
      return;
    }

    let res = { valid: true };

    if (this.validate) {
      try {
        res = await cssValidator.validateText(`.ais { ${this.newProp}: ${this.newVal}; }`);
      }
      catch(e) {
        if (!confirm('There was an error validating the css!\nDo you want to maintain the current value?')) return;
      }
    }

    this.invalidProperty = !res.valid;
    this.invalidCss = false;
    if (this.invalidProperty) return;

    this.newVal = this.newVal.trim();
    if (this.newVal.endsWith(';')) this.newVal = this.newVal.slice(0, -1).trim();
    this.parsedCss[this.newProp] = this.newVal;
    this.updateCssElements();

    this.changePropName();
  }

  newValChange() {
    this.updatePickerColor();
    this.invalidCss = true;
  }

  toggleCustom() {
    if (this.customProp) return;
    if (!this.availableProps.includes(this.newProp)) this.newProp = undefined;
    if (this.fixedProp && !this.fixedProp.includes(this.newVal)) this.newVal = undefined;
  }

  applyPreset() {
    if (this.pagePreset) {
      Object.keys(this.parsedCss).filter(k => k.startsWith("margin"))
        .forEach(k => delete this.parsedCss[k]);
      this.parsedCss = {...this.parsedCss, ...this.pagePreset.styles};
      this.updateCssElements();
    }
  }

  copyStyles($event) {
    $event.preventDefault();
    const copyObj = { ...this.parsedCss };
    this.skipCopyStyles.forEach(s => delete copyObj[s]);
    const copyStr = this.tb.getLayoutFromCssObj(copyObj);
    this.uc.copy(copyStr);
    this.$window.sessionStorage.setItem('fe_css', copyStr);
  }

  pasteStyles($event) {
    const text = this.$window.sessionStorage.getItem('fe_css');
    let styles = {};

    $event.preventDefault();

    if (!text) return;
    try { styles = this.tb.getCssObj(text) }
    catch(e) { this.fs.error(`Couldn't parse the styles.`) }
    
    this.parsedCss = { ...this.parsedCss, ...styles };
    this.updateCssElements();
    this.fs.success(`Pasted from memory:<br/>${text}`);
  }
}

export default {
  bindings: {
    css: "=",
    title: "<",
    validate: "<",
    validProps: "<",
    invalidCss: "=",
    invalidProps: "<",
    allowCustomProps: "<",
    removedProps: "=",
    pageStyles: "<",
    styleRegex: "<",
    allowClassNames: "<",
    classNames: "="
  },
  templateUrl: "form-builder/forms/css-builder/css-builder.component.html",
  controller: CssBuilderCtrl
}